jQuery(function($) {
    /**
    * Make image visible on hover and follow mouse
    */
    function textWithLinks() {
        if (window.innerWidth > 900 && $('.text-with-links-section').length) {
          $(document).on('mousemove', function(event) {
            var containerOffset = $('.text-with-links-section').offset();
            $('.text-with-links-section__img .img:visible').css({
              left: event.pageX - containerOffset.left + 10,
              top: event.pageY - containerOffset.top - 100
            });
          });

          $('.text-with-links-section__text a').hover(function() {
            const index = $(this).index();
            $(`.text-with-links-section__img .img[data-img-index="${index}"]`).show();
          }, function() {
            const index = $(this).index();
            $(`.text-with-links-section__img .img[data-img-index="${index}"]`).hide();
          });
          console.log("bigger");
        } else {
          $(document).off('mousemove');
          console.log("smaller");
          $('.text-with-links-section__text a').off('mouseenter mouseleave');
        }
    }
    $(document).ready(function() {
        textWithLinks();
    });
    $(window).on('resize', function() {
        textWithLinks();
    });

    /**
    * Make right section visible on hovering matching title
    */
    $(document).ready(function() {
        $('.agenda-section__left .hover-btn').hover(function() {
            var id = $(this).data('id');
            $('.agenda-section__left .hover-btn').removeClass('active');
            $('.agenda-section__left .hover-btn').removeClass('arrow');
            $('.agenda-section__right .agenda-section__agenda-item').removeClass('active');
            $(this).addClass('active');
            $(this).addClass('arrow');
            $('.agenda-section__right .agenda-section__agenda-item[data-id=' + id + ']').addClass('active');
        });

        $('.arrangements-section__left .hover-btn').hover(function() {
            var id = $(this).data('id');
            $('.arrangements-section__left .hover-btn').removeClass('active');
            $('.arrangements-section__left .hover-btn').removeClass('arrow');
            $('.arrangements-section__right .arrangements-section__arrangements-item').removeClass('active');
            $(this).addClass('active');
            $(this).addClass('arrow');
            $('.arrangements-section__right .arrangements-section__arrangements-item[data-id=' + id + ']').addClass('active');
        });

        // var index = 0;
        // var $leftLinks = $('.agenda-section__left a');
        // var $rightItems = $('.agenda-section__right .agenda-item');

        // $leftLinks.hover(function() {
        //   clearTimeout(index);
        //   var id = $(this).data('id');
        //   $rightItems.removeClass('active');
        //   $rightItems.filter('[data-id=' + id + ']').addClass('active');
        // });

        // function nextAgenda() {
        //   $rightItems.removeClass('active');
        //   $leftLinks.removeClass('active');
        //   index = (index + 1) % $leftLinks.length;
        //   $leftLinks.eq(index).addClass('active').trigger('mouseenter');
        // }

        // $leftLinks.eq(0).addClass('active');
        // setInterval(nextAgenda, 5000);

        var index = 0;
        var $arrangementsLeftLinks = $('.arrangements-section__left .hover-btn:not(.mobile):visible');
        var $arrangementsRightItems = $('.arrangements-section__right .arrangements-item');
        var $agendaLeftLinks = $('.agenda-section__left .hover-btn:not(.mobile):visible');
        var $agendaRightItems = $('.agenda-section__right .agenda-item');

        $arrangementsLeftLinks.add($agendaLeftLinks).hover(function() {
          clearTimeout(index);
          var id = $(this).data('id');
          $arrangementsRightItems.add($agendaRightItems).removeClass('active');
          $arrangementsRightItems.add($agendaRightItems).filter('[data-id=' + id + ']').addClass('active');
        });

        function nextItem() {
          $arrangementsRightItems.add($agendaRightItems).removeClass('active');
          $arrangementsLeftLinks.add($agendaLeftLinks).removeClass('active');
          index = (index + 1) % ($arrangementsLeftLinks.length + $agendaLeftLinks.length);
          if (index < $arrangementsLeftLinks.length) {
            $arrangementsLeftLinks.eq(index).addClass('active').trigger('mouseenter');
            $arrangementsRightItems.filter('[data-id=' + $arrangementsLeftLinks.eq(index).data('id') + ']').addClass('active');
          } else {
            $agendaLeftLinks.eq(index - $arrangementsLeftLinks.length).addClass('active').trigger('mouseenter');
            $agendaRightItems.filter('[data-id=' + $agendaLeftLinks.eq(index - $arrangementsLeftLinks.length).data('id') + ']').addClass('active');
          }
        }

        $arrangementsLeftLinks.eq(0).addClass('active');
        $arrangementsRightItems.filter('[data-id=' + $arrangementsLeftLinks.eq(0).data('id') + ']').addClass('active');
        setInterval(nextItem, 5000);

    /**
    * Swiper
    */
    var swiper = new Swiper(".image-slider", {
        slidesPerView: "auto",
        loop: true,
        autoplay: true,
        centeredSlides: true,
        spaceBetween: 150,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1200: {
                spaceBetween: 100,
            },
            780: {
                spaceBetween: 50,
            },
            700: {
                spaceBetween: 40,
            },
            0: {
                spaceBetween: 20,
            }
          }
      });

        /**
        * gtranslate menu
        */
        $('.languages-desktop .glink:not(.gt-current-lang)').wrapAll('<div class="sub-menu-language"></div>');
        $(".glink, .sub-menu-language").hover(
            function() {
            $('.sub-menu-language').addClass('active');
            },
            function() {
            $('.sub-menu-language').removeClass('active');
            }
        );
    });

    /**
    * Parallax
    */
    function parallax() {
        var parallaxElements = $(".parallax").filter(function() {
            var elementTop = $(this).offset().top,
                windowHeight = $(window).height(),
                scrollTop = $(window).scrollTop();
          return (scrollTop + windowHeight > elementTop && scrollTop < elementTop + $(this).outerHeight());
        });

        parallaxElements.each(function() {
            var parallaxElement = $(this),
                parallaxTop = parallaxElement.offset().top,
                windowHeight = $(window).height(),
                scrollTop = $(window).scrollTop(),
                parallaxSpeed = 0.2,
                parallaxOffset = 0;

          if (scrollTop + windowHeight > parallaxTop && scrollTop < parallaxTop + parallaxElement.outerHeight()) {
            parallaxOffset = (scrollTop + windowHeight - parallaxTop) * parallaxSpeed;
          }

          if (parallaxElement.hasClass("turned-1")) {
            parallaxElement.css("transform", "translateY(" + parallaxOffset + "px) rotate(273deg)");
          } else if(parallaxElement.hasClass("turned-2")){
            parallaxElement.css("transform", "translateY(" + parallaxOffset + "px) rotate(320deg)");
          } else {
            parallaxElement.css("transform", "translateY(" + parallaxOffset + "px)");
          }
        });
    }

    $(window).on("scroll", function() {
        parallax();
    });
    $(document).ready(function() {
        parallax();
    });

    /**
    * Header overlay zoom effect
    */
    function headerOverlayZoom() {
        var overlay = $(".overlay"),
          maxHeight = 500,
          minHeight = parseInt(overlay.css('background-size'), 10);

        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop(),
            maxScroll = $(document).height() - $(window).height(),
            currentScroll = scrollTop / maxScroll,
            newHeight = (maxHeight - minHeight) * currentScroll + minHeight;

          // Check if the overlay is visible in the viewport
          var overlayTop = overlay.offset().top;
          var overlayBottom = overlayTop + overlay.outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();
          var isVisible = overlayTop < viewportBottom && overlayBottom > viewportTop;

          if (isVisible) {
            if (newHeight > maxHeight) {
              newHeight = maxHeight;
            } else if (newHeight < minHeight) {
              newHeight = minHeight;
            }

            overlay.css("background-size", `${newHeight}%`);
          }
        });
    }
    $(document).ready(function() {
        headerOverlayZoom();
    });
    $( window ).resize(function() {
        headerOverlayZoom();
    });

    /**
    * Mobile menu
    */
    $('.hamburger-menu').on('click', function() {
        $(this).toggleClass('active not-active');
        $('.header__mobile-submenu').toggleClass('active');
        $('body').toggleClass('no-scroll');
    });
    $('.header__mobile-submenu .menu-item-has-children:not(.languages .menu-item-has-children)').on('click', function() {
        $(this).find('.sub-menu').addClass('active');
        $(this).parent().find('.sub-menu').appendTo(".header__mobile-submenu .menu-header-menu-right-container");
        $('.header__mobile-submenu .mobile-menu-back').addClass('active');
        $('.header__mobile-submenu .header__nav-left').css("display","none");
        $(this).parent().find('.menu-item:not(.sub-menu .menu-item)').addClass("active");
        $('.header__mobile-submenu .header__nav-left').css("display","none");
        $('.header__mobile-submenu .socials-wrapper').css("display","none");
        $('.header__mobile-submenu .languages').css("display","none");
    });
    $('.mobile-menu-back').on('click', function() {
        $(this).parent().find('.sub-menu:not(.languages .sub-menu)').appendTo(".header__mobile-submenu .menu-header-menu-right-container .menu-item-has-children");
        $('.header__mobile-submenu .mobile-menu-back').removeClass('active');
        $('.header__mobile-submenu .sub-menu').removeClass('active');
        $('.header__mobile-submenu .header__nav-left').css("display","block");
        $('.header__mobile-submenu .socials-wrapper').css("display","block");
        $('.header__mobile-submenu .languages').css("display","block");
        $(this).parent().find('.menu-item:not(.sub-menu .menu-item)').removeClass("active");
    });
    $( window ).resize(function() {
        if($(window).width() >= 768) {
            $('.hamburger-menu').removeClass('active');
            $('.hamburger-menu').addClass('not-active');
            $('.header__mobile-submenu').removeClass('active');
            $('body').removeClass('no-scroll');
            $('.header__mobile-submenu .sub-menu').removeClass('active');
            $('.header__mobile-submenu').css("display","block");
            $('.header__mobile-submenu .header__nav-left').css("display","block");
        } else {
            $('.hamburger-menu .button').on('click', function() {
                $('.header__mobile-submenu .sub-menu').addClass("active");
                $('.header__mobile-submenu .header__nav-left').css("display","none");
            });
        }
    });

    /**
    * Add class to last block if amount is odd
    */
    if ($(".blocks-section__wrapper .block").length % 2 !== 0) {
        $(".blocks-section__wrapper .block:last-of-type").addClass("grow");
    }

    let clickWeddingConfiguratorBlocked = false;
    $(document).ready(function() {
        // Toggle active state for wedding configurator options in step 5
        $('form[action*="bruiloft-samenstellen"] #fbuilder .fieldname19_1 .three_column label').click(function() {
            if (clickWeddingConfiguratorBlocked) return;
            clickWeddingConfiguratorBlocked = true;
            $(this).toggleClass('active');
            setTimeout(function() {
                clickWeddingConfiguratorBlocked = false;
            }, 200);
        });

        // Show price per person in slider labels of wedding configurator step 2
        $('form[action*="bruiloft-samenstellen"] input[name=fieldname9_1]').on('input change', function() {
            $('form[action*="bruiloft-samenstellen"] .fieldname6_1 label span').text($(this).val() + ' pp');
        });
        $('form[action*="bruiloft-samenstellen"] input[name=fieldname28_1]').on('input change', function() {
            $('form[action*="bruiloft-samenstellen"] .fieldname8_1 label span').text($(this).val() + ' pp');
        });
    });
});

/**
 * Google Maps
 */
// function openMarker(id){
//     google.maps.event.trigger(markers[id], 'click');
// }
// function initMap() {
//     if (typeof locations === 'undefined') {
//         return;
//     }

//     //initialize map
//     //style config: https://mapstyle.withgoogle.com/
//     var styles              = [
//             {
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#f5f5f5"
//                     }
//                 ]
//             },
//             {
//                 "elementType": "labels.icon",
//                 "stylers": [
//                     {
//                         "visibility": "off"
//                     }
//                 ]
//             },
//             {
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#616161"
//                     }
//                 ]
//             },
//             {
//                 "elementType": "labels.text.stroke",
//                 "stylers": [
//                     {
//                         "color": "#f5f5f5"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "administrative.land_parcel",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#bdbdbd"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "poi",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#eeeeee"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "poi",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#757575"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "poi.park",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#e5e5e5"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "poi.park",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#9e9e9e"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#f0ede6"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.arterial",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#757575"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.highway",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#dadada"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.highway",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#616161"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "road.local",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#9e9e9e"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "transit.line",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#e5e5e5"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "transit.station",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#eeeeee"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "water",
//                 "elementType": "geometry",
//                 "stylers": [
//                     {
//                         "color": "#c9c9c9"
//                     }
//                 ]
//             },
//             {
//                 "featureType": "water",
//                 "elementType": "labels.text.fill",
//                 "stylers": [
//                     {
//                         "color": "#9e9e9e"
//                     }
//                 ]
//             }
//         ],
//         myLatLng = {lat: 50.879520, lng: 6.026970}; // Set the initial center of the map

//         args                = {styles : styles, center: myLatLng, zoom: 10},
//         map                 = new google.maps.Map(document.getElementById('gmap'), args),
//         bounds              = new google.maps.LatLngBounds(),
//         infowindow          = new google.maps.InfoWindow(),
//         marker              = null,
//         icon                = null,
//         i                   = 0,
//         windowContent       = null;

//     for (i = 0; i < locations.length; i++) {

//         // make icon
//         overstehof_icon = {
//             url: '/wp-content/themes/carre1749/assets/images/svg/carre1749-map-icon.svg',
//             scaledSize: new google.maps.Size(70, 70),
//             origin: new google.maps.Point(0,0),
//             anchor: new google.maps.Point(16, 16)
//         };

//         icon = {
//             url: '/wp-content/themes/carre1749/assets/images/svg/location-map-icon.svg',
//             scaledSize: new google.maps.Size(50, 50),
//             origin: new google.maps.Point(0,0),
//             anchor: new google.maps.Point(16, 16)
//         };

//         // add marker
//         marker = new google.maps.Marker({
//             position: {lat: parseFloat(locations[i].location.lat), lng: parseFloat(locations[i].location.lng)},
//             icon: icon,
//             title: locations[i].country,
//             map: map,
//             iterator: i
//         });

//         // add info window
//         google.maps.event.addListener(marker, 'click', (function(marker) {
//             return function() {
//                 windowContent = '<div class="gmap-address">';
//                 if (locations[marker.iterator].afb !== false) {
//                     windowContent += "<div class='gmap-image' style='background-image:url(\"" + locations[marker.iterator].afb + "\")'>";
//                     windowContent += '<h3>'+ locations[marker.iterator].name +'</h3>';
//                 } else {
//                     windowContent += '<h3>'+ locations[marker.iterator].name +'</h3>';
//                 }
//                 windowContent += '</div><div class="gmap-content">';
//                 if (locations[marker.iterator].distance !== null) {
//                     windowContent += '<p class="distance">' + locations[marker.iterator].distance + ' vanaf Carré1749</p>';
//                 }
//                 if (locations[marker.iterator].usp.length > 0) {
//                     windowContent += '<ul>';
//                     for (var i = 0; i < locations[marker.iterator].usp.length; i++) {
//                         if (locations[marker.iterator].usp[i] !== null) {
//                             windowContent += '<li>' + locations[marker.iterator].usp[i] + '</li>';
//                         }
//                     }
//                     windowContent += '</ul>';
//                 }
//                 windowContent += '</div></div>';
//                 infowindow.setContent(windowContent);
//                 infowindow.open(map, marker);
//             }
//         })(marker));
//     }
//     overstehof_marker = new google.maps.Marker({
//         position: {lat: 50.879520, lng: 6.026970},
//         map: map,
//         title: "Carré1749",
//         icon: overstehof_icon
//     });
//     google.maps.event.addListener(overstehof_marker, 'click', (function(marker) {
//         return function() {
//             windowContent = '<div class="gmap-address overstehof">';
//             if (overstehof[0]['afb'] !== null) {
//                 windowContent += "<div class='gmap-image' style='background-image:url(\"" + overstehof[0]['afb'] + "\")'>";
//                 windowContent += '<h3>'+ overstehof[0]['name'] +'</h3>';
//             } else {
//                 windowContent += '<h3>'+ overstehof[0]['name'] +'</h3>';
//             }
//             windowContent += '</div><div class="gmap-content">';
//             windowContent += '<p>' + overstehof[0]['location'] + '</p>';
//             windowContent += '<br><p>' + overstehof[0]['phone'] + '</p>';
//             windowContent += '<p>' + overstehof[0]['mail'] + '</p>';
//             if (overstehof[0]['usp'].length > 0) {
//                 windowContent += '<ul>';
//                 for (var i = 0; i < overstehof[0]['usp'].length; i++) {
//                     if (overstehof[0]['usp'][i] !== null) {
//                         windowContent += '<li>' + overstehof[0]['usp'][i] + '</li>';
//                     }
//                 }
//                 windowContent += '</ul>';
//             }
//             windowContent += '</div></div>';
//             windowContent += '</div>';
//             infowindow.setContent(windowContent);
//             infowindow.open(map, overstehof_marker);
//         }

//     })(overstehof_marker));

//     bounds.extend(overstehof_marker.position);


//     // if(locations.length > 1){
//     //     map.fitBounds(bounds);
//     // }
// }

function initMap() {
    if (typeof locations === 'undefined') {
      return;
    }

    // Initialize map
    var map = L.map('map').setView([50.879520, 6.026970], 10);
    var locationIcon = L.icon({
        iconUrl: '/wp-content/themes/carre1749/assets/images/svg/location-map-icon.svg',
        iconSize: [50, 50], // Size of the icon [width, height]
        iconAnchor: [25, 50], // Anchor point of the icon
        popupAnchor: [0, -50] // Position of the popup relative to the icon
    });

    var overstehofIcon = L.icon({
        iconUrl: '/wp-content/themes/carre1749/assets/images/svg/carre1749-map-icon.svg',
        iconSize: [70, 70],
        iconAnchor: [35, 70],
        popupAnchor: [0, -70]
    });

    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    // Add markers for locations
    var markers = L.markerClusterGroup();
    locations.forEach(function(location, i) {
      if (location.location && location.location.lat && location.location.lng) {
        var marker = L.marker([location.location.lat, location.location.lng], { icon: locationIcon }).addTo(map);

        var popupContent = '<div class="popup-content">';
        if (location.afb) {
          popupContent += `<div class='gmap-image' style='background-image:url("${location.afb}")'></div>`;
        }
        popupContent += `<h3>${location.name}</h3>`;
        if (location.distance) {
          popupContent += `<p class="distance">${location.distance} vanaf Carré1749</p>`;
        }
        if (location.usp && location.usp.length) {
          popupContent += '<ul>';
          location.usp.forEach(function(usp) {
            if (usp) {
              popupContent += `<li>${usp}</li>`;
            }
          });
          popupContent += '</ul>';
        }
        popupContent += '</div>';

        marker.bindPopup(popupContent);
        markers.addLayer(marker);
      }
    });

    // Add Overstehof marker
    var overstehofMarker = L.marker([50.879520, 6.026970], { icon: overstehofIcon }).addTo(map);
    if (overstehof[0].afb) {
        var overstehofPopup = `<div class='gmap-image' style='background-image:url("${overstehof[0].afb}")'></div>`;
    }
    overstehofPopup += `<h3>${overstehof[0].name}</h3><p>${overstehof[0].location}</p>`;
    if (overstehof[0].usp.length) {
      overstehofPopup += '<ul>';
      overstehof[0].usp.forEach(function(usp) {
        overstehofPopup += `<li>${usp}</li>`;
      });
      overstehofPopup += '</ul>';
    }
    overstehofMarker.bindPopup(overstehofPopup);

    map.addLayer(markers);
  }
  document.addEventListener('DOMContentLoaded', initMap);

  /*
  function updateComingSoonLabelPosition() {
    const label = document.querySelector('.coming-soon-label');
    const footer = document.querySelector('footer');
    if (!label || !footer) {
      return;
    }

    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue('--site-header-height')) || 0;
    const adminBarHeight = parseFloat(rootStyles.getPropertyValue('--admin-bar-height')) || 0;
    const topBound = headerHeight + adminBarHeight;
    const footerTop = footer.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;

    if (footerTop < viewportHeight) {
      const availableHeight = footerTop - topBound;

      if (availableHeight > 80) {
        label.style.top = `${topBound + (availableHeight / 2)}px`;
        label.style.visibility = 'visible';
      } else {
        label.style.visibility = 'hidden';
      }
    } else {
      label.style.top = '50%';
      label.style.visibility = 'visible';
    }
  }

  function initComingSoonLabel() {
    if (!document.body.classList.contains('coming-soon-page')) {
      return;
    }

    let ticking = false;
    const onScrollOrResize = function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateComingSoonLabelPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    updateComingSoonLabelPosition();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  document.addEventListener('DOMContentLoaded', initComingSoonLabel);
  */